import React, { useState } from "react";
import { createPortal } from "react-dom"; // Added for structural portal rendering
import KOTPrintLayout from "./KOTPrintLayout"; 
import { useAuth } from "../context/AuthContext";

function buildNotificationKey(notification, index) {
  if (notification?.id) return String(notification.id);
  if (notification?.data?.kotId) return `kot-${notification.data.kotId}`;
  if (notification?.timestamp) return `ts-${notification.timestamp}-${index}`;
  return `notification-${index}`;
}

export default function NotificationDropdown({ notifications }) {
  const { user } = useAuth();
  const [activePrintData, setActivePrintData] = useState(null);

  const handleManualPrint = (notification) => {
    const isConfirmed = window.confirm("Do you want to print this KOT?");
    if (!isConfirmed) return;

    // 1. Dig deep into the payload to handle nested formats
    const rawData = notification.data?.data || notification.data || notification;

    // 2. Standardize properties for KOTPrintLayout
    const formattedData = {
      kotId: rawData.kotId || rawData.id || "N/A",
      seatingName: rawData.seatingName || rawData.seating_name || rawData.table || "N/A",
      products: rawData.products || rawData.items || rawData.orderItems || [],
      createdBy: rawData.createdBy || rawData.waiter || "System",
      createdAt: rawData.createdAt || notification.timestamp || new Date().toISOString(),
    };

    // 3. Bind context data
    setActivePrintData(formattedData);

    // 4. Fire print pipeline window
    setTimeout(() => {
      window.print();
      setActivePrintData(null);
    }, 100);
  };

  return (
    <div className="absolute right-0 top-12 bg-white shadow rounded w-64 max-h-64 overflow-y-auto z-50 print:hidden">
      {notifications.length === 0 ? (
        <div className="p-3 text-gray-500">No notifications</div>
      ) : (
        notifications.map((n, index) => (
          <div 
            key={buildNotificationKey(n, index)}
            className="p-3 border-b text-sm hover:bg-gray-100"
          >
            <div className="text-gray-800">{n.message || "New Notification"}</div>
            {n.type === "KOT_Created" && (
              <button 
                type="button" 
                onClick={(e) => {
                  e.stopPropagation();
                  handleManualPrint(n);
                }}
                className="mt-2 px-2 py-1 text-xs bg-indigo-600 text-white rounded hover:bg-indigo-700 transition"
              >
                Print Kot 🖨️
              </button>
            )}
          </div>
        ))
      )}

      {/* Using a React Portal here strips out absolute wrapping constraints 
        by attaching the printer component straight to document.body 
      */}
      {activePrintData && createPortal(
        <KOTPrintLayout data={activePrintData} user={user} />,
        document.body
      )}
    </div>
  );
}